'use client';

import _defineProperty from "/codebuild/output/src2867/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src2867/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["classNames", "styles", "unstyled", "vars", "withAriaAttributes", "onKeyDown", "withKeyboardNavigation", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { useMergedRef } from '@mantine/hooks';
import 'react';
import 'clsx';
import '../../../core/MantineProvider/Mantine.context.mjs';
import '../../../core/MantineProvider/default-theme.mjs';
import '../../../core/MantineProvider/MantineProvider.mjs';
import '../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../../core/MantineProvider/use-props/use-props.mjs';
import '../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../../core/Box/Box.mjs';
import { factory } from '../../../core/factory/factory.mjs';
import '../../../core/DirectionProvider/DirectionProvider.mjs';
import { Input } from '../../Input/Input.mjs';
import { useComboboxContext } from '../Combobox.context.mjs';
import { useComboboxTargetProps } from '../use-combobox-target-props/use-combobox-target-props.mjs';
import classes from '../Combobox.module.css.mjs';
var defaultProps = {
  withAriaAttributes: true,
  withKeyboardNavigation: true
};
var ComboboxSearch = factory(function (_props, ref) {
  var props = useProps("ComboboxSearch", defaultProps, _props);
  var classNames = props.classNames,
    styles = props.styles,
    unstyled = props.unstyled,
    vars = props.vars,
    withAriaAttributes = props.withAriaAttributes,
    onKeyDown = props.onKeyDown,
    withKeyboardNavigation = props.withKeyboardNavigation,
    size = props.size,
    others = _objectWithoutProperties(props, _excluded);
  var ctx = useComboboxContext();
  var _styles = ctx.getStyles("search");
  var targetProps = useComboboxTargetProps({
    targetType: "input",
    withAriaAttributes: withAriaAttributes,
    withKeyboardNavigation: withKeyboardNavigation,
    withExpandedAttribute: false,
    onKeyDown: onKeyDown,
    autoComplete: "off"
  });
  return /* @__PURE__ */jsx(Input, _objectSpread(_objectSpread(_objectSpread({
    ref: useMergedRef(ref, ctx.store.searchRef),
    classNames: [{
      input: _styles.className
    }, classNames],
    styles: [{
      input: _styles.style
    }, styles],
    size: size || ctx.size
  }, targetProps), others), {}, {
    __staticSelector: "Combobox"
  }));
});
ComboboxSearch.classes = classes;
ComboboxSearch.displayName = "@mantine/core/ComboboxSearch";
export { ComboboxSearch };